import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAppContext } from "../../Lib/ContextLib";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL, development_url, production_url } from "../../config";

export default function Login() {
  const history = useNavigate();

  const [buttonLoader, setButtonLoader] = React.useState(false);

  const { setAuthenticated, setAccessOject } = useAppContext();

  const LoginSchema4 = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  return (
    <div className="login-page-premium">
      <div className="login-card-premium">
        <div className="p-4 p-md-5">
          <div className="text-center mb-5">
            <h1 className="login-logo-text mb-2">WolfWin</h1>
            <p className="text-muted font-weight-medium">Admin Control Panel</p>
          </div>

          <Formik
            initialValues={{
              email: "",
              password: "",
              type: "0",
            }}
            validationSchema={LoginSchema4}
            onSubmit={(values) => {
              localStorage.setItem("envType", "0");
              const currentApiUrl = development_url;

              setButtonLoader(true);
              const dto = {
                email: values.email,
                password: values.password,
              };

              axios
                .post(`${currentApiUrl}/api/admin/auth/login`, dto)
                .then((response) => {
                  if (response?.data.status) {
                    localStorage.setItem("token", response?.data?.data.token);
                    localStorage.setItem("user", JSON.stringify(response?.data?.data));
                    localStorage.setItem("email", response?.data?.data.email);
                    setAccessOject(response?.data?.data);
                    axios.defaults.headers.common["token"] = response?.data?.data.token;
                    setAuthenticated(true);
                    toast.success(response?.data?.data.message);
                    history("/dashoard");
                    window.location.reload();
                    setButtonLoader(false);
                  } else {
                    toast.warning(response?.data.message);
                    setButtonLoader(false);
                  }
                })
                .catch((error) => {
                  setButtonLoader(false);
                  toast.error(error?.response?.data.message);
                });
            }}
          >
            {({ touched, errors, handleChange }) => (
              <Form>
                <div className="mb-4">
                  <div className="login-field-wrapper">
                    <Field
                      type="email"
                      name="email"
                      className={`form-control login-input-premium ${touched.email && errors.email ? "is-invalid" : ""}`}
                      placeholder="Email Address"
                    />
                    <i className="fas fa-envelope login-field-icon"></i>
                  </div>
                  <ErrorMessage component="div" name="email" className="login-error-message" />
                </div>

                <div className="mb-4">
                  <div className="login-field-wrapper">
                    <Field
                      type="password"
                      name="password"
                      className={`form-control login-input-premium ${touched.password && errors.password ? "is-invalid" : ""}`}
                      placeholder="Password"
                    />
                    <i className="fas fa-lock login-field-icon"></i>
                  </div>
                  <ErrorMessage component="div" name="password" className="login-error-message" />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-block login-submit-btn mt-4"
                  disabled={buttonLoader}
                >
                  {buttonLoader ? (
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                  ) : (
                    "Sign In"
                  )}
                </button>
                
                <div className="text-center mt-4">
                  <small className="text-muted">© 2026 WolfWin Admin Panel</small>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}
